import React, {Component} from 'react';
import {IMAGE_PATH} from 'Constants';

class MapMarker extends Component {
  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div>
        <img src={IMAGE_PATH + "icons/map-marker-icon.png"} height="35" width="25"/>
      </div>
    );
  }
}

export default MapMarker;
